import axios from './index';

/**
 * Types
 */
import type { Response } from '@/dtos/common.dto';
import type { QuerySystemLogDto } from '@/dtos/system-log.dto';

type SystemLogOptions = {
    /** 操作列表 */
    actions: string[];
    /** 模块列表 */
    modules: string[];
};

/**
 * APIs
 */
// 获取系统日志列表
export function systemLogs(params?: QuerySystemLogDto) {
    return axios<Response<any[]>>('/v1/system-logs', {
        method: 'get',
        params,
    });
}

// 获取搜索选项列表
export function systemLogOptions() {
    return axios<Response<SystemLogOptions>>('/v1/system-logs/options', {
        method: 'get',
    });
}
